import React, { useEffect, useState } from 'react';
import { Button, Result, Space, Typography } from 'antd';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { token_client_id, token_url } from './setting';

const NotifyBind = ({

}) => {
    const { code } = useParams()
    const [user, setUser] = useState();
    const getUser = () => {
        axios
            .get('/system/user_per')
            .then(response => {
                setUser((response.data?.data || []).find(_ => true))
                if (!response.data.data.find(_ => true)?.line_notify_token) {
                    if (code) {
                        axios
                            .post('/qrcode/notify_bind',
                                {
                                    code: code
                                }
                            )
                            .then((response) => {
                                setUser((response.data?.data || []).find(_ => true))
                            })
                    } else {
                        setTimeout(() => {
                            window.location.href = `https://notify-bot.line.me/oauth/authorize?response_type=code&scope=notify&client_id=${token_client_id}&redirect_uri=${token_url}&state=ffdvgdfg`;
                        }, 2000)
                    }
                }
            })
    }
    useEffect(() => {
        getUser()
    }, [])
    return (<>
        {(!user?.line_notify_token) &&
            <Result
                status="warning"
                title="您尚未綁定Line Notify"
                subTitle="請稍後帶您前往綁定"
                extra={[
                ]}
            />}
        {(user?.line_notify_token) &&
            <Result
                status="success"
                title="通知綁定完成"
                subTitle={<>
                    <Space direction={'vertical'}>
                        <>感謝您的綁定</>
                        <>若您綁定的是群組，請將Line Notify邀請至群組中。</>
                    </Space>
                </>}
                extra={[
                    <Button >
                        返回首頁
                    </Button>,
                ]}
            />}
    </>)
}
export default NotifyBind